import { Store } from 'vuex';
import { Mutations } from '@/store/modules/navigation';

import signup from '@/api/signup';
import { ISignupState } from '@/api/signup/interface';
import { logger } from '@/util/logger';

// TODO add IRootState
export default (store: Store<any>) => {
  const queue: Array<{ page: string; info: ISignupState }> = [];
  store.subscribe(async (mutation) => {
    if (mutation.type !== 'navigation/' + Mutations.SET_PAGE) {
      // token updated set the pending in the queue
      if (mutation.type === 'updateToken') {
        logger.log('emptying the queue', queue.length);
        queue.map((x) => signup.customerState(x.page, x.info));
      }
      return;
    }
    const info: ISignupState = store.getters['user/info'];
    const page = mutation.payload.name;
    if (!store.getters.token) {
      logger.log('token not available, adding info to the queue');
      queue.push({ page, info });
    } else {
      signup.customerState(page, info);
    }
  });
};
